import * as types from '../types';

export const setLayoutSettings = data => dispatch => {
  dispatch({
    type: types.SET_LAYOUT_SETTINGS,
    data: data
  });
};

export const setDefaultSettings = data => dispatch => {
  dispatch({
    type: types.SET_DEFAULT_LAYOUT_SETTINGS,
    data: data
  });
};
